import { MdSpaceDashboard } from "react-icons/md";
import { Link, useLocation } from "react-router";
import { FaCalendarAlt } from "react-icons/fa";
import styles from "./Sidebar.module.scss";
import { FaUser } from "react-icons/fa";
import React from "react";

function Sidebar() {
  const location = useLocation();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.linksContainer}>
        <Link
          to="/"
          className={`${styles.link} ${location.pathname === "/" ? styles.active : ""}`}
        >
          <MdSpaceDashboard />
          <p>Home</p>
        </Link>
        <Link
          to="/bookings"
          className={`${styles.link} ${location.pathname?.includes("/bookings") ? styles.active : ""}`}
        >
          <FaCalendarAlt />
          <p>Bookings</p>
        </Link>
        <Link
          to="/profile"
          className={`${styles.link} ${location.pathname?.includes("/profile") ? styles.active : ""}`}
        >
          <FaUser />
          <p>Profile</p>
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;
